import React from 'react';
import { StorylineState } from "../../../store/storyline/types";
import { connect } from "react-redux";
import { RootState } from "../../../store";
import { updateParameterValue } from "../../../store/storyline/actions";
import { Slider as BaseSlider } from "../../../shared/components";
import { DocumentedComponent } from '../../../shared/components/DocumentedComponent';

interface Props {
    storyline: StorylineState;
    updateParameterValue: typeof updateParameterValue;
    name: string;
}

export function _Slider(props: Props) {
    const { storyline, updateParameterValue, name, ...rest } = props;
    const [value, setValue] = React.useState(storyline.parameterValues.get(name) || 0);


    const handleChange = (event: any, newValue: number | number[]) => {
        updateParameterValue(name, newValue);
        setValue(newValue);
    };

    React.useEffect(() => {
        
        if (storyline.parameterValues.has(name)) {
            const newValue = storyline.parameterValues.get(name);
            if (newValue !== value) {
                setValue(newValue);
            }
        }
        
    }, [storyline.parameterValues]);

    return (
        <BaseSlider
            valueLabelDisplay="on"
            color="primary"
            name={name}
            {...rest}
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            onChangeCommitted={handleChange}
        />
    );
}

const Slider = connect(
    (state: RootState) => ({
        storyline: state.storyline
    }),
    { updateParameterValue: updateParameterValue as any })(_Slider);

(Slider as DocumentedComponent).metadata = {
    description: "The Slider control allows the user to select a numeric value within a range.  Min/max values and step sizes can be configured.",
    isSelfClosing: true,
    attributes: [
        { name: "name", type: "string", description: "The name of the variable that the selected value will be read from and persisted to. The underlying component's `data-testid` attribute will be set to this value. This is useful for targeting the element via Playwright, Puppeteer or similar UI testing tools. Can be overridden via an explicit `data-testid` value." },
        { name: "min", type: "number", description: "The minimum value that can be selected." },
        { name: "max", type: "number", description: "The maximum value that can be selected." },
        { name: "step", type: "number", description: "The increment by which the value can be changed." },
        { name: "orientation", type: "string", options: ["horizontal", "vertical"], description: "The orientation of the slider. Can be either `horizontal` or `vertical`. Optional - defaults to `horizontal`." },
    ]
};

export default Slider;